import React, { Component } from 'react';
import { PropTypes, instanceOf } from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { withCookies, Cookies } from 'react-cookie';
import {
    AVATAR_ID_COOKIE, LOGIN_TOKEN_TYPE_COOKIE, LOGIN_TOKEN_TYPE_SNAPCHAT,
    LOGIN_TOKEN_TYPE_BSAUTH
} from './constants/cookie_constants';
import CongratsView from './components/congrats_view/CongratsView';
import LoginView from './components/login_view/LoginView';
import CookieStorageService from './services/CookieStorageService';
import { config } from './constants/config_constants';
import ChromeExtensionService from './services/ChromeExtensionService';
import * as session_handlers from './actions/session_handler';
import './App.css';


const WEB_STORE_CHROME_EXT_URL = `https://chrome.google.com/webstore/detail/bitmoji/${config.chrome_ext_id}`;
class App extends Component {
    componentWillMount() {
        const { cookies } = this.props;

        // determine if chrome extension is installed is user not logged in
        ChromeExtensionService.sendMessage({signal: 'BitmojiWebAppConnected'},
            (response) => {
                if (typeof response === 'undefined') {
                    window.location.href = WEB_STORE_CHROME_EXT_URL;
                }
            });


        // check if user is already logged in
        const loginTokenType = CookieStorageService.get(LOGIN_TOKEN_TYPE_COOKIE, cookies);
        if (loginTokenType) {
            if (loginTokenType === LOGIN_TOKEN_TYPE_BSAUTH ) {
                this.props.updateLoginSession(true, LOGIN_TOKEN_TYPE_BSAUTH);
            }
            else if (loginTokenType === LOGIN_TOKEN_TYPE_SNAPCHAT) {
                // let's check if the user is still logged into chrome extension
                this.props.updateLoginSession(true, LOGIN_TOKEN_TYPE_SNAPCHAT);
            } else {
                // cookie is corrupted
                CookieStorageService.clearAllCookies(cookies);
            }
        }
    }

    componentDidMount() {

        const { location, history, cookies } = this.props;

        // check if state and code are passed back
        const params = new URLSearchParams(location.search);
        const state = params.get('state');
        const code = params.get('code');

        if (state && code) {
            history.replace('.');

            ChromeExtensionService.sendMessage({signal: 'BitmojiWebAppCompleteUserLogin', code: code, state: state},
                (response) => {
                    if ((typeof response !== 'undefined') && response.signal === 'ChromeExtLoginSuccess') {
                        CookieStorageService.set(LOGIN_TOKEN_TYPE_COOKIE, LOGIN_TOKEN_TYPE_SNAPCHAT, cookies);
                        CookieStorageService.set(AVATAR_ID_COOKIE, response.avatarData.id, cookies);

                        // clear query params and update store state
                        this.props.updateLoginSession(true, LOGIN_TOKEN_TYPE_SNAPCHAT);
                    }
                    else{
                        this.props.updateLoginError(true);
                    }
                });

            this.props.updateUserLoggingIn(true);
        }
    }

    render() {
        const { session } = this.props;

        return (
            <div className="BitmojiApp">
                { session.isLoggedIn ?
                    <CongratsView /> : <LoginView /> }
            </div>
        );
    }
}

App.propTypes = {
    session: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    updateLoginSession: PropTypes.func.isRequired,
    updateUserLoggingIn: PropTypes.func.isRequired,
    updateLoginError: PropTypes.func.isRequired,
    cookies: instanceOf(Cookies).isRequired
};

export default connect(state => ({
    session: state.sessionReducer
}), session_handlers)(withRouter(withCookies(App)));



// WEBPACK FOOTER //
// ./src/App.js